import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-circle-icon',
  standalone: true,
  templateUrl: './circle-icon.component.html',
})
export class CircleIconComponent {
  @Input() colorClass: string = 'text-white';
  @HostBinding('class') get hostClass() {
    return this.colorClass;
  }
}
